import { useEffect } from 'react';
import {
	FacebookShareButton,
	FacebookIcon,
	FacebookMessengerShareButton,
	FacebookMessengerIcon,
	TwitterShareButton,
	TwitterIcon,
	EmailShareButton,
	EmailIcon,
	WhatsappShareButton,
	WhatsappIcon,
	LinkedinShareButton,
	LinkedinIcon,
	LineShareButton,
	LineIcon,
} from 'react-share';

const fbAppId = '151511935580331';

const SocialShareButtons = ({ url }: { url: string }) => {
	useEffect(() => {
		document.title = 'Mussila - Christmas Calendar';
	}, []);
	return (
		<div className='flex flex-row gap-2 flex-wrap max-w-[160px] md:max-w-none'>
			<FacebookShareButton url={url}>
				<FacebookIcon
					className='text-[#0a0727] hover:text-[#3b5998] ring ring-white ring-inset rounded-full w-8 h-8 md:w-12 md:h-12'
					bgStyle={{fill: 'currentColor'}}
					round
				/>
			</FacebookShareButton>
			<FacebookMessengerShareButton appId={fbAppId} url={url}>
				<FacebookMessengerIcon
					className='text-[#0a0727] hover:text-[#2196f3] ring ring-white ring-inset rounded-full w-8 h-8 md:w-12 md:h-12'
					bgStyle={{fill: 'currentColor'}}
					round
				/>
			</FacebookMessengerShareButton>
			<TwitterShareButton url={url}>
				<TwitterIcon
					className='text-[#0a0727] hover:text-[#00aced] ring ring-white ring-inset rounded-full w-8 h-8 md:w-12 md:h-12'
					bgStyle={{fill: 'currentColor'}}
					round
				/>
			</TwitterShareButton>
			<EmailShareButton url={url}>
				<EmailIcon
					className='text-[#0a0727] hover:text-[#7f7f7f] ring ring-white ring-inset rounded-full w-8 h-8 md:w-12 md:h-12'
					bgStyle={{fill: 'currentColor'}}
					round
				/>
			</EmailShareButton>
			<WhatsappShareButton url={url}>
				<WhatsappIcon
					className='text-[#0a0727] hover:text-[#25d366] ring ring-white ring-inset rounded-full w-8 h-8 md:w-12 md:h-12'
					bgStyle={{fill: 'currentColor'}}
					round
				/>
			</WhatsappShareButton>
			<LinkedinShareButton url={url}>
				<LinkedinIcon
					className='text-[#0a0727] hover:text-[#007fb1] ring ring-white ring-inset rounded-full w-8 h-8 md:w-12 md:h-12'
					bgStyle={{fill: 'currentColor'}}
					round
				/>
			</LinkedinShareButton>
			<LineShareButton url={url}>
				<LineIcon
					className='text-[#0a0727] hover:text-[#00b800] ring ring-white ring-inset rounded-full w-8 h-8 md:w-12 md:h-12'
					bgStyle={{fill: 'currentColor'}}
					round
				/>
			</LineShareButton>
		</div>
	);
};

export default SocialShareButtons;
